import {Sidebar} from "primereact/sidebar";
import {useContext, useRef, useState} from "react";
import {LayoutContext} from "./context/LayoutContext";
import {baseUrl} from "../utils/webInfo";
import callToast from "../utils/helper";
import {Toast} from "primereact/toast";
import {useNavigate} from "react-router-dom";

const AppProfileSidebar = () => {
    const {layoutState, setLayoutState, accessToken, setAccessToken, profileInfo} = useContext(LayoutContext);
    const [logoutLoading, setLogoutLoading] = useState(false)
    const toast = useRef<Toast | null>(null);
    const navigate = useNavigate();

    const onProfileSidebarHide = () => {
        setLayoutState((prevState) => ({
            ...prevState,
            profileSidebarVisible: false,
        }));
    };



    // logout
    const handleSignOut = async () => {
        try {
            setLogoutLoading(true)
            // const notificationToken = localStorage.getItem("notificationToken")
            // if (notificationToken) {
            //     await handleNotificationUnSubscription(notificationToken, messaging, accessToken)
            // }

            const res = await fetch(`${baseUrl?.url}/api/logout`, {
                method: "GET",
                credentials: "include",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (res.ok) {
                callToast(toast, true, "Logout successfully");
                localStorage.setItem("isLogin", "0");
                setAccessToken("");
                navigate('/auth/login')
                // router.push("/auth/login");
            } else {
                const resData = await res.json()
                callToast(toast, false, resData?.error);
            }
        } catch (error: any) {
            callToast(toast, "warn", error?.message);
        } finally {
            setLogoutLoading(false)
            onProfileSidebarHide();
            localStorage.setItem("isLogin", "0");
            navigate('/auth/login')
            // router.push("/auth/login");
        }
    };

    return (
        <Sidebar
            visible={layoutState.profileSidebarVisible}
            onHide={onProfileSidebarHide}
            position="right"
            className="layout-profile-sidebar w-full sm:w-25rem"
        >
            <div className="flex flex-column mx-auto md:mx-0">
                <span className="mb-2 font-semibold">Welcome</span>
                <span className="text-color-secondary font-medium mb-5">
                    {profileInfo?.role_type?.name} | {profileInfo?.name}
                </span>

                <ul className="list-none m-0 p-0">
                    {/*<li>*/}
                    {/*    <div*/}
                    {/*        className="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">*/}
                    {/*        <span>*/}
                    {/*            <i className="pi pi-user text-xl text-primary"></i>*/}
                    {/*        </span>*/}
                    {/*        <div className="ml-3">*/}
                    {/*            <span className="mb-2 font-semibold">*/}
                    {/*                Profile*/}
                    {/*            </span>*/}
                    {/*            /!*<p className="text-color-secondary m-0">*!/*/}
                    {/*            /!*    Lorem ipsum date visale*!/*/}
                    {/*            /!*</p>*!/*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</li>*/}

                    <li>
                        <div
                            onClick={() => {
                                if (!logoutLoading) {
                                    handleSignOut().then()
                                }
                            }}
                            className="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
                            <span>
                                <i className="pi pi-power-off text-xl text-primary"></i>
                            </span>
                            <div className="ml-3">
                                <span className="mb-2 font-semibold">
                                    Sign Out
                                </span>
                                {/*<p className="text-color-secondary m-0">*/}
                                {/*    Sed ut perspiciatis*/}
                                {/*</p>*/}
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </Sidebar>
    );
};

export default AppProfileSidebar;
